export var defaultIsItemRemovableFunction = function (item) { return true; };
//# sourceMappingURL=utils.js.map